import {connect} from 'react-redux';
import InteractionsMenu from './InteractionsMenu';
import {deleteFile, deleteOrderFile} from '../../../../modules/Inspection/actions/files/deleteFile';
import {updateFileMetadata} from '../../../../modules/Inspection/actions/files/updateFileMetadata';
import {getFileList} from '../../../../modules/Inspection/actions/files/getFileList';
import {editFile, editOrderFile} from '../../../../modules/Inspection/actions/files/uploadFile';
import {getFile} from '../../../../modules/Inspection/actions/files/getFile';
import {getFileFromOrder} from '../../../actions/files/getFile';
import {showGlobalErrorMessage} from '../../../actions/globalErrorMessage/showGlobalErrorMessage';
import {getShumaStepStatus} from '../../../../modules/Inspection/actions/steps/getShumaStepStatus';

export default connect(
  null,
  {
    deleteFile,
    deleteOrderFile,
    updateFileMetadata,
    getFileList,
    uploadFile: editFile,
    uploadOrderFile: editOrderFile,
    getFile,
    getFileFromOrder,
    showGlobalErrorMessage,
    getShumaStepStatus
  }
)(InteractionsMenu);
